import Http from '../http'

export const index = (page, name) => Http.get(`/categories?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/categories', { data }, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/categories/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/categories/${id}`, { headers: { Authorization: localStorage.token } })
export const storeFiles = (data) => Http.post('/company-category-files', data, { headers: { Authorization: localStorage.token } })
